function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.198 9.726h1.167c.38 0 .695-.309.695-.696V6.521h2.467c.38 0 .695-.308.695-.695v-.955a.695.695 0 00-.695-.695H6.06V1.673a.695.695 0 00-.695-.696H4.198a.695.695 0 00-.695.696v2.509H1.036a.695.695 0 00-.695.695v.955c0 .381.308.695.695.695h2.467v2.51c0 .38.308.695.695.695v-.006z",
  fill: "#fff"
})));